import { render, staticRenderFns } from "./mpvue-calendar.vue?vue&type=template&id=2947f353&"
import script from "./mpvue-calendar.vue?vue&type=script&lang=js&"
export * from "./mpvue-calendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports